import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { buildSitemap, PortalLink, PortalLinkContext, PortalLinkGroup, SitemapSection } from 'src/app/@core/navigation/portal-links';
import { PortalNavigationService } from 'src/app/@core/navigation/portal-navigation.service';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from 'src/app/shared/models/item.model';

/** Sitemap (Unified Code criterion 37), built from the same link definitions as the header and the footer. */
@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.scss'],
})
export class SitemapComponent implements OnInit, OnDestroy {
  private destroySubject: Subject<void> = new Subject();
  sections: SitemapSection[] = [];
  isRtl = true;

  constructor(private portalNavigationService: PortalNavigationService, private langService: LanguageService) {}

  ngOnInit(): void {
    scrollTo(0, 0);
    this.isRtl = this.langService.getCurrentLanguage() === LanguageEnum.ar;
    this.langService.languageChange
      .pipe(takeUntil(this.destroySubject))
      .subscribe((result: LanguageEnum) => (this.isRtl = result === LanguageEnum.ar));
    this.portalNavigationService.context$
      .pipe(takeUntil(this.destroySubject))
      .subscribe((context: PortalLinkContext) => (this.sections = buildSitemap(context)));
  }

  linkText(link: PortalLink): string {
    return (this.isRtl ? link.titleAr || link.title : link.title || link.titleAr) ?? '';
  }

  groupHeading(group: PortalLinkGroup): string {
    return (this.isRtl ? group.headingAr || group.heading : group.heading || group.headingAr) ?? '';
  }

  trackById(_: number, item: { id: string }): string {
    return item.id;
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
